import React, { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import style from './style.module.less'

interface ModalProps {
  children: ReactNode
}

interface Props {
  onFinish: () => void
}

const Modal = ({ children }: ModalProps) => {
  return createPortal(children, document.body)
}

const FinishedModal = ({ onFinish }: Props) => {
  const [countDown, setCountDown] = useState(5)

  useEffect(
    () => {
      const timer = setInterval(() => {
        setCountDown(countDown - 1)
      }, 1000)
      if (countDown === 0) {
        onFinish()
        clearInterval(timer)
      }
      return () => {
        clearInterval(timer)
      }
    },
    [countDown, onFinish]
  )

  return (
    <Modal>
      <div className={style.finishedModal}>
        <div className={style.container}>
          <div className={style.box}>
            <div className={style.top} />
            <div className={style.bottom}>
              <div className={style.title}>恭喜您完成开店任务</div>
              <div className={style.subTitle}>开启线上经营之路吧~</div>
              <button className={style.button} onClick={onFinish}>
                立即开启({countDown}s)
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default FinishedModal
